import _ from 'lodash';
import GraphicPoint from './graphics/point';
import GraphicLine from './graphics/line';
import GraphicPolygon from './graphics/polygon';
import GraphicBlockPoint from './graphics/blockPoint';
import GraphicPanoramaPoint from './graphics/panoramaPoint';
import GraphicArea from './graphics/area';

class Graphic {
  static buildGraphic(payload, stage) {
    if (payload.type === 'point') {
      if (payload.group_type === 'PanoramaPoint' && payload.property.type === '91') {
        return new GraphicPanoramaPoint(payload, stage);
      }
      return new GraphicPoint(payload, stage);
    }
    if (payload.type === 'blockPoint') {
      return new GraphicBlockPoint(payload, stage);
    }
    if (payload.type === 'line') {
      return new GraphicLine(payload, stage);
    }
    if (payload.type === 'polygon') {
      return new GraphicPolygon(payload, stage);
    }
    if (payload.type === 'area') {
      return new GraphicArea(payload, stage);
    }

    return null;
  }
}

export default Graphic;
